import * as React from 'react';
import './landing.css';

class Landing extends React.Component {
    public render() {
        return (
            <div className="Landing">
                <Header />
                <Content />
            </div>
        )
    }
}


function Header() {
    return (
        <div className="Landing-header">
            <img src="assets/images/gyrony-name-no-border-opt.svg" className="Landing-logo" alt="logo" />
        </div>
    )
}

function Content() {
    return (
        <div className="Landing-content">
            <div className="temp-content">
                <h1>Hi&nbsp;there! thanks&nbsp;for&nbsp;dropping&nbsp;by...</h1>
                <h2>Gyrony.com offers&nbsp;a range&nbsp;of&nbsp;services</h2>
                <h3>Including<br/>IT&nbsp;Consulting&nbsp;and&nbsp;Web&nbsp;Development<br/>Graphic,&nbsp;Jewelry,&nbsp;and&nbsp;Garden&nbsp;Design</h3>
                <p>We're getting things set up...<br />
                    Why don't you head over to our Facebook Page to see what's going on...
                </p>
                <br />
                <div className="facebook">
                    <a href="https://www.facebook.com/gyrony" target="_blank">
                        <img src="./assets/images/flogo_rgb_hex-brc-site-250.png" alt="Visit our Facebook Page" width="60" />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default Landing; 



// WEBPACK FOOTER //
// ./src/pages/landing.tsx